/**
 * cs-klaviyo-tracking.js — "Updated Added to Cart" for Klaviyo
 *
 * Intercepts successful /cart/add fetch calls, reads /cart.js for
 * full cart state, and pushes an "Updated Added to Cart" event.
 *
 * Ported from Focal theme (layout/theme.liquid lines 334-387) with fixes:
 * - Removed console.log debug logging
 * - res.ok guard (skip failed add-to-cart)
 * - Klaviyo API compat wrapper (klaviyo.push > _learnq fallback)
 * - Uses Theme.routes for cart URLs
 * - Absolute direct_checkout_link via window.location.origin
 * - Correct URL matching (Focal's .includes() was backwards)
 * - Double-patch guard (__klaviyoCartTracking)
 * - Deferred patch: waits for window load so Klaviyo's embed loads first
 * - Uses XMLHttpRequest for /cart.js read to avoid fetch recursion
 */
(function () {
  if (window.__klaviyoCartTracking) return;
  window.__klaviyoCartTracking = true;

  /**
   * Klaviyo compatibility: Focal used klaviyo.push() (Klaviyo v3 onsite object).
   * Prefer window.klaviyo if available, fall back to window._learnq (legacy queue).
   */
  function klaviyoTrack(eventName, payload) {
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['track', eventName, payload]);
    } else {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, payload]);
    }
  }

  // Theme is defined as const in scripts.liquid (not on window).
  // Safe to reference directly since this file loads with defer.
  function getCartPath() {
    try { return Theme.routes.cart_url; } catch (e) { return '/cart'; }
  }

  /**
   * Read /cart.js using XMLHttpRequest to avoid triggering our own
   * fetch interceptor (which would cause recursion).
   */
  function readCart(callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', window.location.origin + getCartPath() + '.js');
    xhr.onload = function () {
      if (xhr.status === 200) {
        try { callback(JSON.parse(xhr.responseText)); } catch (e) { /* silent */ }
      }
    };
    xhr.send();
  }

  function sendUpdatedAddedToCart() {
    readCart(function (data) {
      if (!data.items || data.items.length === 0) return;

      var cartBase = window.location.origin + getCartPath() + '/';
      var parts = [];
      data.items.forEach(function (item) {
        parts.push(item.variant_id + ':' + item.quantity);
      });

      var cart = {
        total_price: data.total_price / 100,
        $value: data.total_price / 100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price / 100,
        items: data.items,
        direct_checkout_link: cartBase + parts.join(',')
      };

      klaviyoTrack('Updated Added to Cart', cart);
    });
  }

  /**
   * Patch fetch AFTER all scripts have loaded. Klaviyo's onsite embed
   * also patches window.fetch — if we patch too early, Klaviyo overwrites us.
   * By waiting for 'load', we patch last and wrap whatever fetch exists,
   * including Klaviyo's wrapper.
   */
  function patchFetch() {
    var currentFetch = window.fetch;
    window.fetch = function () {
      var response = currentFetch.apply(this, arguments);
      response.then(function (res) {
        if (res.ok && res.url && res.url.indexOf('/cart/add') !== -1) {
          sendUpdatedAddedToCart();
        }
      }).catch(function () {});
      return response;
    };
  }

  // If page already loaded (e.g. script injected late), patch immediately.
  // Otherwise wait for load event.
  if (document.readyState === 'complete') {
    patchFetch();
  } else {
    window.addEventListener('load', patchFetch);
  }
})();
